import * as operationsApi from '@/network/api/operations/operations.api.js'
import * as cardsApi from '@/network/api/cards/cards.api.js'

/** requests cards solicitation list
@return { Promise }
*/
export const getCardsSolicitationsList = async (context, payload) => {
    const res = await cardsApi.getCardsSolicitationsList(payload)

    if (res) context.commit('SAVE_CARDS_SOLICITATIONS', { pageNumber: payload.pageNumber, data: res.data.data })

    return res
}

/** requests operation details
@return { promise } - Operation details request
*/
export const requestOperationDetails = async (context, payload) => {
    const res = await operationsApi.getOperationGenericDetail(payload)

    if (res) context.commit('SAVE_OPERATION_DETAILS', res.data.data)
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
